module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGMIDA78TwlmGDVg1IBRA4aLAQDbevQQ+rvZkwAAAABJRU5ErkJggg=="